import smaIcon from "../img/smaIcon.png";
import telkomIcon from "../img/telkomIcon.png";
import silvertechIcon from "../img/silvertechIcon.jpg";
import productzillaIcon from "../img/productzillaIcon.jpg";
import binarIcon from "../img/binarIcon.jpg";
import binusIcon from "../img/binusIcon.jpg";
import asystIcon from "../img/asystIcon.webp";

export const data = [
  {
    id: 1,
    name: "SMA Negeri 4 Jakarta",
    description: "Science major",
    image: smaIcon,
    year: "2017 - 2020",
  },
  {
    id: 2,
    name: "Telkom University",
    description: "D3 Information Systems",
    image: telkomIcon,
    year: "2020 - 2023",
  },
  {
    id: 3,
    name: "PT Aero System Indonesia",
    description: "Software Enginerr Internship",
    image: asystIcon,
    year: "2022 - 2023",
  },
  {
    id: 4,
    name: "SilverTech Asia",
    description: "Software Enginerr Fulltime",
    image: silvertechIcon,
    year: "2023 - Present",
  },
  {
    id: 5,
    name: "Productzilla Academy (Bootcamp)",
    description: "React JS Bootcamp",
    image: productzillaIcon,
    year: "2024 - 2024",
  },
  {
    id: 6,
    name: "Binar Academy (Bootcamp)",
    description: "Fullstack Web Developer",
    image: binarIcon,
    year: "2024 - 2024",
  },
  {
    id: 7,
    name: "Binus University",
    description: "Extension Program System Information",
    image: binusIcon,
    year: "2024 - Present",
  },
];
